import { Card, Button, Popover } from "antd";
import styles from "./styles.module.scss";
import { mockData, typesIcons } from "../mock";
import { useState } from "react";
import OrdersModal from "@components/PoModal";
import classNames from "classnames";

import PlusCircle from "@assets/icons/PlusCircle.svg";
import { GanttChart } from "../../ProductLaunch/components/Details/GanttChart";

const Scheduler = ({ styleGrid }) => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeToggle, setActiveToggle] = useState("actual");
  const [expandedSoNumbers, setExpandedSoNumbers] = useState({});
  const handleViewOrders = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  const handleToggle = (toggle) => {
    setActiveToggle(toggle);
  };

  const toggleSoNumber = (index) => {
    setExpandedSoNumbers((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const TooltipContent = () => (
    <div className={styles.tooltipContent}>Active</div>
  );

  return (
    <div className={styles.scheduler}>
      <div className={styles.schedulerToggle}>
        <button
          className={classNames(styles.btnToggle, {
            [styles.active]: activeToggle === "actual",
          })}
          onClick={() => handleToggle("actual")}
        >
          Actual
        </button>
        <button
          className={classNames(styles.btnToggle, {
            [styles.active]: activeToggle === "history",
          })}
          onClick={() => handleToggle("history")}
        >
          History
        </button>
      </div>

      {activeToggle === "actual" && (
        <>
          <div className={classNames(styles.gridContainer, styleGrid)}>
            <div className={styles.schedulerContainer}>
              <h1 className={styles.verticalText}>Scheduler</h1>
            </div>
            {mockData.map((order, index) => (
              <div key={index} className={styles.gridItemWrapper}>
                <div className={styles.gridItem}>
                  <Card className={styles.card}>
                    <div className={styles.poStatus}>
                      <span>
                        <span className={styles.po}>PO:</span> {order.poNumber}
                      </span>
                      <Popover
                        content={TooltipContent()}
                        trigger="hover"
                        placement="top"
                        overlayClassName="m-customPopover"
                      >
                        <div className={styles.dot} />
                      </Popover>
                    </div>
                    <div>
                      <span className={styles.amount}>COGS:</span> {order.cogs}
                    </div>
                    <div>
                      <span className={styles.amount}>Order Date:</span>{" "}
                      {order.orderDate}
                    </div>
                    <div>
                      <span className={styles.amount}>Shipment Date:</span>{" "}
                      {order.shipmentDate}
                    </div>

                    <Button
                      type="link"
                      className={styles.viewButton}
                      onClick={() => handleViewOrders(order)}
                    >
                      View Details
                    </Button>
                  </Card>
                </div>

                {order.soNumbers && (
                  <div className={styles.soNumbers}>
                    {order.soNumbers.map((so, soIndex) => (
                      <div key={soIndex} className={styles.card}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="18"
                          viewBox="0 0 19 18"
                          fill="none"
                          className={classNames(styles.arrow, {
                            [styles.expanded]:
                              expandedSoNumbers[`${index}-${soIndex}`],
                          })}
                          onClick={() => toggleSoNumber(`${index}-${soIndex}`)}
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.24584 7.11443C2.8837 6.73321 2.8837 6.13509 3.24584 5.75387C3.63526 5.34393 4.28868 5.34393 4.6781 5.75387L8.79673 10.0895C9.20225 10.5164 9.88268 10.5164 10.2882 10.0895L14.4068 5.75387C14.7963 5.34393 15.4497 5.34393 15.8391 5.75387C16.2012 6.13509 16.2012 6.73321 15.8391 7.11443L10.2882 12.9578C9.88268 13.3847 9.20225 13.3847 8.79673 12.9578L3.24584 7.11443Z"
                            fill="white"
                          />
                        </svg>
                        <div className={styles.soInfo}>
                          <span className={styles.icon}>
                            {typesIcons[so.type] || ""}
                          </span>
                          <div className={styles.soStatus}>
                            <span className={styles.soNumber}>
                              {so.soNumber}
                            </span>
                            <div className={styles.dot} />
                          </div>
                        </div>
                        {expandedSoNumbers[`${index}-${soIndex}`] && (
                          <div className={styles.inner}>
                            <div>
                              <span className={styles.shippingCosts}>
                                <span className={styles.label}>
                                  Shipping Costs:
                                </span>{" "}
                                {so.shippingCosts}
                              </span>
                            </div>
                            <div>
                              <span className={styles.deliveryDate}>
                                <span className={styles.label}>
                                  Delivery Date:
                                </span>{" "}
                                {so.deliveryDate}
                              </span>
                            </div>
                            <Button
                              type="link"
                              className={styles.soBtn}
                              onClick={() => handleViewOrders(order)}
                            >
                              set as warehoused
                            </Button>
                            <Button
                              type="link"
                              className={styles.soBtn}
                              onClick={() => handleViewOrders(order)}
                            >
                              View Details
                            </Button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                <div className={styles.addNew}>
                  <img src={PlusCircle} alt="plus" />
                  Add new SO
                </div>
              </div>
            ))}
          </div>
          <GanttChart />
        </>
      )}
      {isModalOpen && (
        <OrdersModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          order={selectedOrder}
        />
      )}
    </div>
  );
};

export default Scheduler;
